import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { formatPath } from "~helpers/path";
import useTranslate from "../useTranslate/useTranslate";

function LinkCustom({
  children = <></>,
  to = "",
  activeClassName = "",
  partiallyActive = false,
  external = false,
  nofollow = false,
  ...other
}) {
  const ariaLabel = useTranslate(
    `ariaLabel-${other?.label}Link`,
    `${other?.label} Link`
  );

  if (!to) {
    return <>{children}</>;
  }
  if (external) {
    return (
      <a
        href={to}
        className="spotlights-gtm"
        title={other.label}
        target="_blank"
        rel="noreferrer"
        aria-label={ariaLabel}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      rel={nofollow ? "nofollow" : null}
      to={formatPath(to)}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      {...other}
    >
      {children}
    </Link>
  );
}

LinkCustom.propTypes = {
  to: PropTypes.string,
  nofollow: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.any,
  ]),
  activeClassName: PropTypes.string,
  partiallyActive: PropTypes.bool,
  gtmClass: PropTypes.string,
  external: PropTypes.bool,
};

export default LinkCustom;
